class PostAPI {
  static all(state) {
    let url = this.postsUrl(state)

    return fetch(url, {
      credentials: 'same-origin'
    }).then(this.handleStatus)
  }

  static handleStatus(response) {
    if (!response.ok) {
      // Fetch doesn't reject on HTTP error status
      throw Error(`Products PostAPI: Request rejected with status ${response.status}`)
    }
    return response
  }

  static postsUrl(params) {
    const { currentTerms } = params

    let orderby = this.orderQuery()

    // Get term queries
    let currentModel = currentTerms.product_model
    let model = currentModel ? `&product_model=${currentModel}` : ''

    let currentStyle = currentTerms.product_style
    let style = currentStyle ? `&product_style=${currentStyle}` : ''

    // Combine query
    let query = model + style

    return `/wp-json/wp/v2/product?per_page=99&${orderby}${query}`
  }

  static orderQuery() {
    return 'orderby=menu_order'
  }
}

export default PostAPI



// WEBPACK FOOTER //
// ./src/js/products/api/PostAPI.js